import { atom } from "nanostores";
import { isBackgroundPlayerPaused } from "./playerStore";

export const isModalOpen = atom(false);
export const isSearchModalOpen = atom(false);
export const iframeTitle = atom("");
export const iframeSrc = atom("");

interface IFrameProps {
  src: string;
  title: string;
}

export function openIFrameModal(props: IFrameProps) {
  const { src, title } = props;
  isBackgroundPlayerPaused.set(true);
  isModalOpen.set(true);
  iframeSrc.set(src);
  iframeTitle.set(title);
}

export function closeModal() {
  isBackgroundPlayerPaused.set(false);
  isModalOpen.set(false);
}

export function openSearchModal() {
  isSearchModalOpen.set(true);
}